import { defineComponent as _defineComponent } from 'vue'
import HistoryItemJob from '@/components/formats/ShokurekishoParts/HistoryItemJob.vue'
import {
  descriptionMaxLength,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumeJobHistoryCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const formatData = useEnglishResumeFormatData()
const {
  activeHistoryItem,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  addProjectHistory,
  deleteHistoryDetail,
  moveJobHistoryDetail,
  activateHistoryItem
} = useEnglishResumeHistoriesApi()

return { __sfc: true,formatData, activeHistoryItem, addJobHistory, deleteJobHistory, moveJobHistory, addProjectHistory, deleteHistoryDetail, moveJobHistoryDetail, activateHistoryItem, HistoryItemJob, descriptionMaxLength }
}

})